var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 300,
    viewBox: "0 0 278 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8498 296.337C30.7209 299.274 38.3175 300.071 45.6486 298.626C52.9797 297.18 59.7049 293.559 64.947 288.234L139 214.584L213.053 288.234C216.506 291.737 220.619 294.521 225.155 296.424C229.691 298.327 234.559 299.311 239.478 299.32C244.534 299.305 249.537 298.292 254.2 296.337C261.128 293.534 267.049 288.707 271.19 282.487C275.332 276.266 277.502 268.942 277.417 261.469V62.9167C277.397 46.2363 270.762 30.2448 258.967 18.4499C247.172 6.6551 231.18 0.0199805 214.5 0L63.4999 0C46.8195 0.0199805 30.828 6.6551 19.0332 18.4499C7.23834 30.2448 0.603227 46.2363 0.583246 62.9167V261.469C0.502044 268.947 2.67933 276.276 6.83041 282.497C10.9815 288.718 16.9132 293.542 23.8498 296.337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilled);
export default __webpack_public_path__ + "static/media/bookmark-filled.97699e1854c58dccddf956a00c28e12e.svg";
export { ForwardRef as ReactComponent };